import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@hmsexp/component-library';
import ContentLoader from '../../../components/Common/LoadingComp/ContentLoader';
import RectLoader from '../../../components/Common/LoadingComp/RectLoader';

const FeedBackGridLoader = () => {
  const { palette } = useTheme();

  const columns = [
    { start: 0, width: 20 },
    { start: 22, width: 18 },
    { start: 42, width: 15 },
    { start: 59, width: 20 },
    { start: 81, width: 17 }
  ];

  const rows = 10;
  const rowHeight = 38;
  const rowGap = 22;
  const totalHeight = rows * (rowHeight + rowGap);

  return (
    <View style={{ flex: 1, padding: 12 }}>

      <ContentLoader
        height={60}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}
        style={{ marginBottom: 20 }}>
        <RectLoader x='0' y='15' width='30%' height='22' rx='6' ry='6' />
        <RectLoader x='35%' y='15' width='15%' height='22' rx='6' ry='6' />
        <RectLoader x='53%' y='15' width='15%' height='22' rx='6' ry='6' />
      </ContentLoader>

      <ContentLoader
        height={50}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}
        style={{ marginBottom: 20 }}>
        <RectLoader x='0' y='15' width='20%' height='20' rx='6' ry='6' />
        <RectLoader x='24%' y='15' width='18%' height='20' rx='6' ry='6' />
      </ContentLoader>

      <ContentLoader
        height={45}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}
        style={{ marginBottom: 15 }}>
        {columns.map((col, index) => (
          <RectLoader key={index} x={`${col.start}%`} y='12' width={`${col.width}%`} height='22' rx='6' ry='6' />
        ))}
      </ContentLoader>


      <ContentLoader
        height={totalHeight}
        backgroundColor={palette.primaryBackgroundLow}
        foregroundColor={palette.primaryOutline}>
        {Array.from({ length: rows }).map((_, idx) => {
          const y = idx * (rowHeight + rowGap); 

          return (
            <React.Fragment key={idx}>
              {columns.map((col, colIdx) => (
                <RectLoader
                  key={`${idx}-${colIdx}`}
                  x={`${col.start}%`}
                  y={y}
                  width={`${col.width}%`}
                  height={rowHeight}
                  rx='6'
                  ry='6'
                />
              ))}
            </React.Fragment>
          );
        })}
      </ContentLoader>
    </View>
  );
};

export default FeedBackGridLoader;
